import styled from 'styled-components';
import { ProgressBarProps } from './interface';

export const Container = styled.div<ProgressBarProps>`
  width: 90%;
  height: 60px;
  background: #e0e0de;
  border-radius: 10px;
  margin: 50px;

  div {
    width: ${(props) => props.completed}%;
    height: 100%;
    background: ${(props) => props.bgColor};
    border-radius: inherit;
    justify-content: center;
    align-items: center;
    display: flex;

    span {
      padding: 5px;
      color: #ffffff;
      font-weight: bold;
    }
  }
`;
